import axios from "axios";
import organizationUrls from "utils/urls/organizationUrls";

const blockedOrganization = async (value, id) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  const res = await axios.patch(
    organizationUrls.usersOrganizationsUrlWithoutParams(id),
    {
      is_blocked: value,
    },
    {
      headers: headersInternal,
    }
  );
  return res;
};

const deleteOrganization = (id) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  return axios.delete(organizationUrls.usersOrganizationsUrlWithoutParams(id), {
    headers: headersInternal,
  });
};

const activateOrganization = async (value, id) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  const res = await axios.patch(
    organizationUrls.usersOrganizationsUrlWithoutParams(id),
    {
      is_active: value,
    },
    {
      headers: headersInternal,
    }
  );
  return res;
};

const getOrgWithUser = async (id) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  const res = await axios.get(
    organizationUrls.usersOrganizationsUrlWithoutParams(id),
    {
      headers: headersInternal,
    }
  );

  return res;
};

const getOrganizations = async (sort_by) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  const res = await axios.get(
    organizationUrls.usersOrganizationsUrlWithoutParams(),
    {
      params: {
        ordering: Number(sort_by) === 1 ? "-title" : "title",
      },
      headers: headersInternal,
    }
  );
  const response = {
    status: res.status,
    data: {
      count: res.data.lenght,
      next: null,
      previous: null,
      results: res.data,
    },
  };
  return response;
};

const getOrganization = async (title) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  const res = await axios.get(organizationUrls.usersOrganizationsUrl(), {
    params: {
      search: title,
      search_fields: "title",
    },
    headers: headersInternal,
  });
  if (res.data.status === "404") {
    return false;
  }
  return true;
};

const getBlockedOrganizations = async (sort_by) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  const res = await axios.get(organizationUrls.usersOrganizationsUrl(), {
    params: {
      search: 1,
      search_fields: "is_blocked",
      ordering: Number(sort_by) === 1 ? "-title" : "title",
    },
    headers: headersInternal,
  });
  const response = {
    status: res.status,
    data: {
      count: res.data.length,
      results: res.data,
    },
  };
  return response;
};

const handleSearchTitle = async (title) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  const res = await axios.get(organizationUrls.organizationsUrl(), {
    params: {
      search: title,
      search_fields: "title",
    },
    headers: headersInternal,
  });
  const response = {
    status: res.status,
    data: {
      count: res.data.lenght,
      next: null,
      previous: null,
      results: res.data,
    },
  };
  return response;
};

const getNumericOrganization = async (sort_by) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  const res = await axios.get(organizationUrls.usersOrganizationsUrl(), {
    params: {
      type: "numeric",
      ordering: Number(sort_by) === 1 ? "-title" : "title",
    },
    headers: headersInternal,
  });
  return res;
};

const addNewOrganization = async (data) => {
  const res = await axios.post(
    organizationUrls.usersOrganizationsUrlWithoutParams(),
    data,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );

  const response = {
    status: res.status,
    data: res.data,
  };
  return response;
};

const getAlphabeticalOrganization = (sort_by) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  const res = axios.get(organizationUrls.usersOrganizationsUrl(), {
    params: {
      type: "alpha",
      ordering: Number(sort_by) === 1 ? "-title" : "title",
    },
    headers: headersInternal,
  });
  return res;
};

const searchAlphabaticOrganizations = async (title) => {
  const res = await axios.get(
    organizationUrls.searchOrganizationsAlphabetical(),
    {
      params: {
        title,
      },
    }
  );
  if (res.data.status === "404") {
    return false;
  }
  return true;
};

const searchNumericOrganizations = async (title) => {
  const res = await axios.get(organizationUrls.searchOrganizationsNumeric(), {
    params: {
      title,
    },
  });
  if (res.data.status === "404") {
    return false;
  }
  return true;
};

const filterNumericOrganizations = (Filterdata) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  return axios.get(organizationUrls.filterOrganizationsUrl(), {
    params: {
      type: "numeric",
      ordering: Number(Filterdata.sortBy) === 1 ? "-title" : "title",
      titles: Filterdata.filterTitles,
    },

    headers: headersInternal,
  });
};

const filterAlphaNumericOrganizations = (Filterdata) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  return axios.get(organizationUrls.filterOrganizationsUrl(), {
    params: {
      type: "alpha",
      ordering: Number(Filterdata.sortBy) === 1 ? "-title" : "title",
      titles: Filterdata.filterTitles,
    },
    headers: headersInternal,
  });
};

const filterGetOrganizations = async (Filterdata) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };

  const url = organizationUrls.getFilteredOrganizations();

  const res = await axios.get(url, {
    params: {
      ordering: Number(Filterdata.sortBy) === 1 ? "-title" : "title",
      ...(Filterdata.filterTitles ? { titles: Filterdata.filterTitles } : {}),
    },
    headers: headersInternal,
  });
  return {
    status: res.status,
    data: {
      count: res.data.lenght,
      next: null,
      previous: null,
      results: res.data,
    },
  };
};

const filterLockOrganizations = async (Filterdata) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  const res = await axios.get(organizationUrls.filterOrganizationsUrl(), {
    params: {
      ordering: Number(Filterdata.sortBy) === 1 ? "-title" : "title",
      titles: Filterdata.filterTitles,
      search: 1,
      search_fields: "is_blocked",
    },
    headers: headersInternal,
  });

  return {
    status: res.status,
    data: {
      count: res.data.lenght,
      next: null,
      previous: null,
      results: res.data,
    },
  };
};

const filterAlphaOrganizationsUser = async (Filterdata) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };

  const res = await axios.get(organizationUrls.filterOrganizationsUrl(), {
    params: {
      type: "alpha",
      ordering: Number(Filterdata.sortBy) === 1 ? "-title" : "title",
      ...(Filterdata.filterTitles ? { titles: Filterdata.filterTitles } : {}),
    },
    headers: headersInternal,
  });

  return res;
};

const filterNumericOrganizationsUser = (Filterdata) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  return axios.get(organizationUrls.filterOrganizationsUrl(), {
    params: {
      type: "numeric",
      ordering: Number(Filterdata.sortBy) === 1 ? "-title" : "title",
      titles: Filterdata.filterTitles,
    },
    headers: headersInternal,
  });
};

const exportData = async (startDate, endDate, sortBy, filterTitles) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  const res = await axios.get(organizationUrls.exportData(), {
    params: {
      ordering: Number(sortBy) === 1 ? "-title" : "title",
      start_date: startDate,
      end_date: endDate,
      ids: filterTitles,
    },
    headers: headersInternal,
  });
  return res;
};

export default {
  blockedOrganization,
  deleteOrganization,
  activateOrganization,
  getOrgWithUser,
  getOrganizations,
  getOrganization,
  getBlockedOrganizations,
  handleSearchTitle,
  getNumericOrganization,
  addNewOrganization,
  getAlphabeticalOrganization,
  searchAlphabaticOrganizations,
  searchNumericOrganizations,
  filterNumericOrganizations,
  filterAlphaNumericOrganizations,
  filterGetOrganizations,
  filterLockOrganizations,
  filterAlphaOrganizationsUser,
  filterNumericOrganizationsUser,
  exportData,
};
